export default __webpack_public_path__ + "static/media/ok.7f40db2e.svg";